import { createCrud } from '@lumahealthhq/ui-model';
var basePath = 'largeLanguageModelPrompts';
var crud = createCrud(basePath);

/* Default queries */
export var useLargeLanguageModelPromptsCount = crud.makeCount();
export var useLargeLanguageModelPromptsById = crud.makeFindById();
export var useLargeLanguageModelPromptsByIds = crud.makeFindByIds();
export var useLargeLanguageModelPromptsMany = crud.makeFindMany();
export var useLargeLanguageModelPromptsOne = crud.makeFindOne();
export var useLargeLanguageModelPromptsPagination = crud.makePagination();

/* Default mutations */
export var useLargeLanguageModelPromptsCreateOne = crud.makeCreateOne();
export var useLargeLanguageModelPromptsUpdateOne = crud.makeUpdateOne();
export var useLargeLanguageModelPromptsRemoveById = crud.makeRemoveById();